export const questionTypes = Object.freeze({
  select: 'select',
  input: 'input',
  number: 'number',
  file: 'file',
  richText: 'richText'
});
export type QuestionTypeType = (typeof questionTypes)[keyof typeof questionTypes];
export const validationTypes = Object.freeze({
  REGEXP: 'REGEXP',
  MINVAL: 'MINVAL',
  MAXVAL: 'MAXVAL',
  MAX_FILE_SIZE: 'MAX_FILE_SIZE',
  ACCEPTED_FILE_TYPES: 'ACCEPTED_FILE_TYPES',
  MIN_WORDS: 'MIN_WORDS',
  MAX_WORDS: 'MAX_WORDS'
});
export const tagValidations = [validationTypes.MIN_WORDS, validationTypes.MAX_WORDS];
export type ValidationType = (typeof validationTypes)[keyof typeof validationTypes];
export const ALLOWED_FILE_TYPES_DEFAULT_OPTIONS = {
  __ungrouped: [],
  Image: [{
    id: 'jpeg',
    label: 'JPEG'
  }, {
    id: 'jpg',
    label: 'JPG'
  }, {
    id: 'png',
    label: 'PNG'
  }, {
    id: 'webp',
    label: 'WebP'
  }, {
    id: 'gif',
    label: 'GIF'
  }, {
    id: 'bmp',
    label: 'BMP'
  }],
  Document: [{
    id: 'pdf',
    label: 'PDF'
  }, {
    id: 'doc',
    label: 'DOC'
  }, {
    id: 'docx',
    label: 'DOCX'
  }, {
    id: 'ppt',
    label: 'PPT'
  }, {
    id: 'pptx',
    label: 'PPTX'
  }, {
    id: 'odp',
    label: 'ODP'
  }, {
    id: 'xls',
    label: 'XLS'
  }, {
    id: 'xlsx',
    label: 'XLSX'
  }, {
    id: 'csv',
    label: 'CSV'
  }, {
    id: 'txt',
    label: 'TXT'
  }, {
    id: 'html',
    label: 'HTML'
  }],
  Video: [{
    id: 'mp4',
    label: 'MP4'
  }, {
    id: 'mpg',
    label: 'MPG'
  }, {
    id: 'mpeg',
    label: 'MPEG'
  }, {
    id: 'webm',
    label: 'WebM'
  }, {
    id: 'avi',
    label: 'AVI'
  }, {
    id: 'flv',
    label: 'FLV'
  }],
  Audio: [{
    id: 'mp3',
    label: 'MP3'
  }, {
    id: 'aac',
    label: 'AAC'
  }, {
    id: 'flac',
    label: 'CSV'
  }, {
    id: 'wav',
    label: 'WAV'
  }]
};
export const MAX_FILE_SIZE_UNITS = [{
  id: 'MB',
  label: 'MB'
}, {
  id: 'KB',
  label: 'KB'
}];
export const MAX_ALLOWED_FILE_SIZE = 10 * 1000 * 1000; // 10 MB

export const TERRABLOB_METADATA_KEY = 'terrablobPath';